import { render, staticRenderFns } from "./PayAgrConfigChooseDialog.vue?vue&type=template&id=9087150e&scoped=true"
import script from "./PayAgrConfigChooseDialog.vue?vue&type=script&lang=js"
export * from "./PayAgrConfigChooseDialog.vue?vue&type=script&lang=js"
import style0 from "./PayAgrConfigChooseDialog.vue?vue&type=style&index=0&id=9087150e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9087150e",
  null
  
)

export default component.exports